import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { SButton, SButtonProps } from "components/parts";
import { STheme } from "components/styles";
/**
 * 通常ボタン
 */

/**
 * プロパティ
 */
type Props = SButtonProps;
/**
 * 通常ボタン
 *
 * @param label: ボタンのラベル
 * @param index: フォーカス番号(1～)
 * @param gridColumn: CSSグリッドの列位置を指定する
 * @param gridRow: CSSグリッドの行位置を指定する
 * @param disabled: 非活性
 * @returns JSX.Element
 */
export const SNormalButton = (props: Props): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <SButton {...props} />
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: STheme.buttons.normal,
            color: STheme.buttons.text,
            ":hover": {
              backgroundColor: STheme.buttons.hover.normal,
              color: STheme.buttons.hover.text,
            },
            padding: "1px 4px",
          },
        },
      },
    },
  },
  { ...STheme }
);
